import { render, staticRenderFns } from "./TranslationsIndexComponent.vue?vue&type=template&id=05f63a09&scoped=true"
import script from "./TranslationsIndexComponent.vue?vue&type=script&lang=js"
export * from "./TranslationsIndexComponent.vue?vue&type=script&lang=js"
import style0 from "./TranslationsIndexComponent.vue?vue&type=style&index=0&id=05f63a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f63a09",
  null
  
)

export default component.exports